import { Link, NavigateFunction, useNavigate } from "react-router";
import parse, { attributesToProps, domToReact, HTMLReactParserOptions } from 'html-react-parser';
import { classNames } from "@ct-react/core";
import { DataProps } from "../../tools/components";
import { Wrapper } from "../layout/wrapper";
import RatioImage from "../medias/ratio-image";
import Button from "../common/button";
import "./repeatable-section.scss";

const htmlParseOptions = (navigate: NavigateFunction): HTMLReactParserOptions => ({
  replace: domNode => {
    if (domNode.type !== "tag") return;
    switch (domNode.name) {
      case "dl":
        //@ts-ignore
        return (<div className="scrollable-wrap"><dl>{domToReact(domNode.children)}</dl></div>);
      case "a":
        const { href, class: className, ...rest } = domNode.attribs;
        if (!/^\/(?!\/)/.test(href)) return;
        //@ts-ignore
        const children = domToReact(domNode.children);
        const props = attributesToProps(rest);
        return /has-uppercase/.test(className)
          ? <Button type="button" className="link" onClick={() => navigate(href)}>{children}</Button>
          : <Link to={href} className={className} {...props}>{children}</Link>
      default:
        return;
    }
  }
});

const RepeatableSection = ({ className, data }: DataProps<any>) => {

  const navigate = useNavigate();
  const wrapperClasses = classNames("content cms-section-content", className);

  return (

    <Wrapper.Centered className={wrapperClasses}>
      {!!data["section-image"] &&
        <RatioImage className="media"
                    source={data["section-image"].assets}
                    alt={data["section-image"].alternativeText} />
      }
      <div className="inner">
        {!!data["section-name"] &&
          <h2>{data["section-name"]}</h2>
        }
        {!!data["section-detail"] &&
          <div className="richtext">
            {parse(data["section-detail"], htmlParseOptions(navigate))}
          </div>
        }
      </div>
    </Wrapper.Centered>);

};

export default RepeatableSection;
